import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    FormControlLabel,
    Switch,
    CardActions,
    TextField,
    InputAdornment,
    Box,
    Tooltip
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { TextFieldNumber } from "src/_modules/common";
import { InfoOutlined } from "@mui/icons-material";

export default function EstimationTime({
    profile,
    handleChange,
    onEstimationTimeUpdated,
    loading,
    error,
    isSuccess,
    validationErrors
}) {
    const { t } = useTranslation();

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={
                <Box display="flex" alignItems="center" gap={2}>
                    <Tooltip placement="top" title={t("stopPointHint")}>
                        <InfoOutlined color="primary" />
                    </Tooltip>
                    <Typography variant="h6">
                        {t("Expected time for each stop point")}
                    </Typography>
                </Box>
            } />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <FormControlLabel
                    control={
                        <Switch
                            checked={profile?.arrivalTime}
                            onChange={({ target: { checked } }) => handleChange({ target: { name: "arrivalTime", value: checked } })}
                        />
                    }
                    label={t(profile?.arrivalTime ? "Enabled" : "Disabled")} />
                <TextFieldNumber
                    disabled={!profile?.arrivalTime}
                    name="orderServiceTime"
                    value={profile?.orderServiceTime}
                    onChange={handleChange}
                    variant="outlined"
                    size="small"
                    max={999999}
                    fullWidth
                    InputProps={{
                        endAdornment: <InputAdornment position="start">{t("Minutes")}</InputAdornment>,
                    }}
                    error={validationErrors?.orderServiceTime}
                />
            </CardContent>
            <Divider />
            <CardActions sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: 'row-reverse' }}>
                <LoadingButton
                    variant="contained"
                    loading={loading}
                    onClick={onEstimationTimeUpdated}
                >{t("Confirm")}
                </LoadingButton>
                {!!isSuccess && <Typography color="success.main">{t("Updated successfully")}</Typography>}
                {!!error && <Typography color="error">{t(error)}</Typography>}
            </CardActions>
        </Card>
    );
};

